export default __webpack_public_path__ + "static/media/cloud-left.a8c1b152.png";